// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"filter-sort"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fill-rule":"evenodd","stroke-linecap":"square","stroke-width":2,"clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21.62 18.7651L20.0001 20.3896L18.3799 18.7651M21.62 15.222L20.0001 13.5996L18.3799 15.222","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-filter-sort')
export default class FilterSortIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-sort',
    }
  }
}
